var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label mdl-color-text--grey-600"},[_vm._v(" "+_vm._s(_vm.conversationData.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }